/* global isPool */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import flatten from 'lodash/flatten'
import map from 'lodash/map'
import groupBy from 'lodash/groupBy'
// todo fix
import modelUtil from './util/model_util'

const roundTypes = {
    quarterfinals: isPool ? 'Pool' : 'Quarterfinals',
    semifinals: 'Semifinals',
    finals: 'Finals',
    all: 'All Rounds',
}

function getRoundType(round) {
    if (Number(round) === 1) {
        return roundTypes.quarterfinals
    }
    if (Number(round) === 2) {
        return roundTypes.semifinals
    }

    return roundTypes.finals
}

// Flattens Round into an single nested object
function toFlatRound(round, batter) {
    return {
        round: round.round,
        roundType: round.roundType,
        playerId: batter.playerId,
        playerName: batter.playerName,
        complete: batter.complete,
        hits: batter.hits,
    }
}

function toAllRounds(rounds) {
    const first = rounds[0]

    return {
        playerId: first.playerId,
        playerName: first.playerName,
        round: 0,
        roundType: roundTypes.all,
        hits: flatten(map(rounds, 'hits')),
    }
}

// creates an 'All Batters' summary set
function toAll(rounds) {
    const name = 'All Batters'
    const hitsQuarterfinals = flatten(
        map(
            rounds.filter((d) => d.roundType === roundTypes.quarterfinals),
            'hits'
        )
    )
    const hitsSemifinals = flatten(
        map(
            rounds.filter((d) => d.roundType === roundTypes.semifinals),
            'hits'
        )
    )
    const hitsFinals = flatten(
        map(
            rounds.filter((d) => d.roundType === roundTypes.finals),
            'hits'
        )
    )
    const hitsAll = flatten([hitsQuarterfinals, hitsSemifinals, hitsFinals])

    const allRounds = []

    if (hitsQuarterfinals.length > 0) {
        allRounds.push({
            hits: hitsQuarterfinals,
            playerId: -1,
            playerName: name,
            round: -1,
            roundType: roundTypes.quarterfinals,
        })
    }
    if (hitsSemifinals.length > 0) {
        allRounds.push({
            hits: hitsSemifinals,
            playerId: -1,
            playerName: name,
            round: -1,
            roundType: roundTypes.semifinals,
        })
    }
    if (hitsFinals.length > 0) {
        allRounds.push({
            hits: hitsFinals,
            playerId: -1,
            playerName: name,
            round: -1,
            roundType: roundTypes.finals,
        })
    }
    if (hitsAll.length > 0) {
        allRounds.push({
            hits: hitsAll,
            playerId: -1,
            playerName: name,
            round: -1,
            roundType: roundTypes.all,
        })
    }
    return allRounds
}

// Mimics old Rounds layout. Loops through rounds, seeds, players and creates an object of all batters rounds
function populateRounds(hits) {
    const roundBreakdown = []

    const rounds = groupBy(hits, (d) => d.round)

    let roundCount = 1
    for (const round in rounds) {
        const seeds = groupBy(rounds[round], (d) => d.seed)

        for (const seed in seeds) {
            const breakdown = {}
            breakdown.roundType = getRoundType(rounds[round][0].round)

            breakdown.round = roundCount
            roundCount += 1
            const players = groupBy(seeds[seed], (d) => d.playerId)

            breakdown.batters = []
            for (const player in players) {
                const batter = {}
                batter.playerId = players[player][0].playerId
                batter.homers = players[player].length
                batter.playerName = players[player][0].playerName
                batter.hits = players[player]
                batter.complete = players[player][0].complete
                breakdown.batters.push(batter)
            }
            roundBreakdown.push(breakdown)
        }
    }
    return roundBreakdown
}

// populates rounds and players sets
export default function model(hits, prevHits, derbyData) {
    const flatRounds = []

    const delta = modelUtil.diff(prevHits, hits)

    // console.log('---------- new data: ', delta);

    const battersMap = hits.reduce((acc, curr) => {
        if (acc[curr.playerId]) {
            return acc
        }

        acc[curr.playerId] = {
            playerId: curr.playerId,
            playerName: curr.playerName,
            complete: curr.complete,
        }

        return acc
    }, {})

    const batters = Object.values(battersMap)

    // convert from source format to SimData's rounds format
    const rounds = populateRounds(hits)

    // Flattens rounds... can probably deprecate this
    rounds.forEach((round) => {
        round.batters.forEach((batter) => {
            flatRounds.push(toFlatRound(round, batter))
        })
    })

    const players = batters.map((b) => {
        const playerRounds = flatRounds.filter((d) => d.playerId === b.playerId)

        if (playerRounds.length > 1) {
            playerRounds.push(toAllRounds(playerRounds))
        }

        return playerRounds
    })

    players.push(toAll(flatRounds))

    // determine LPR, if any
    const livePlayerRound = modelUtil.livePlayerRound(flatRounds, derbyData)

    const activePlayer = livePlayerRound?.playerId || -1
    const activeRoundType = livePlayerRound?.roundType || 'All Rounds'

    // if (livePlayerRound) {
    //     console.log('LPR - ' + livePlayerRound.playerName + ', ' + livePlayerRound.roundType);
    // } else {
    //     console.log('LPR: none');
    // }

    return {
        activePlayer,
        activeRoundType,
        rounds,
        players,
        delta,
        livePlayerRound,
    }
}
